import { createFeatureSelector, createSelector } from '@ngrx/store';
import { retailerFeatureKey, RetailerState } from './retailer-reducer';

export const getFilterRetailerState =
  createFeatureSelector<RetailerState>(retailerFeatureKey);

export const getRetailerState = createSelector(
  getFilterRetailerState,
  (state: RetailerState) => state
);
